/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useUpdateAdditionalOrdData } from '@/shared/api'
import ContragentCard from '@/shared/components/contragent-card'
import { CheckIcon, ContentContainer } from '@/shared/ui'
import {
    ContragentResponse,
    VkOrdApiKeyResponse,
} from '@synapex/shared2/gateway-rest-api'
import { AccountWorkspaceDescriptor } from '@synapex/shared2/entities'

type AdvertiserProps = {
    ordData: VkOrdApiKeyResponse | undefined | null
} & AccountWorkspaceDescriptor

const Advertiser: React.FC<AdvertiserProps> = ({ ordData, ...аwsDescr }) => {
    const { mutateAsync: updateAdditionalOrdData } =
        useUpdateAdditionalOrdData()

    function handleSelectContragent(contragent: ContragentResponse | null) {
        void updateAdditionalOrdData({
            awd: аwsDescr,
            input: {
                adOrdContragentId: contragent?.ord_contragent_id || null,
            },
        })
    }

    const isAgencyMode = ordData?.currentLinkType === 'agency'

    const isAgencySelected = !!ordData?.adOrdAgencyId

    const canEditAdvertiser =
        !!ordData?.vkOrdApiKey &&
        (!isAgencyMode || (isAgencyMode && isAgencySelected))

    const tooltipMessage = !ordData?.vkOrdApiKey
        ? 'Если хотите изменить, добавте API ключ ОРД'
        : 'Чтобы выбрать рекламодателя, сначала выберите агентство'

    return (
        <ContentContainer>
            <div className="flex items-center gap-[10px] pb-3">
                <h2 className="text-lg font-extrabold">
                    Реквизиты рекламодателя
                </h2>
                <CheckIcon
                    className="h-4 w-4"
                    checked={!!ordData?.adOrdContragentId}
                />
            </div>

            <div className="w-[302px]">
                <ContragentCard
                    {...аwsDescr}
                    onSelectContragent={handleSelectContragent}
                    allowEdit={canEditAdvertiser}
                    currentContragentId={ordData?.adOrdContragentId}
                    tooltipMessage={tooltipMessage}
                    roleType="advertiser"
                />
            </div>
        </ContentContainer>
    )
}

export default Advertiser
